import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'

export default component((node, ctx) => {
  const json = JSON.parse(node.querySelector('.js-product-json').innerHTML)
  const form = node.querySelector('form')
  // const dataMain = node.querySelector('[data-option-main]')
  const { selectedOrFirstAvailableVariant, product, variantQuantities } = json

  product.variants = product.variants.map(variant => {
    return { ...variant, inventory_quantity: variantQuantities[variant.id] }
  })

  product.variants
  .filter(variant => !variant.available)
  .forEach(variant => {
    const option = document.getElementById(variant.title);
    // console.log(option) 
    option.disabled = true
    option.classList.add('is-unavailable')
    option.nextElementSibling.innerHTML += '- SOLDOUT'
  })

  let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

  form.addEventListener('submit', e => {
    e.preventDefault()
    currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]
    let properties = {};

    if (document.querySelector('[name="properties[Fabric]"]')) {
      const fabricChoice = document.querySelector('[name="properties[Fabric]"]').value;

      properties = {
        fabric: fabricChoice
      }
    }



    addVariant(currentVariant, form.elements.quantity.value, properties)
    console.log(json)
  })

  //  dataMain.selectedIndex = 0;
  //  console.log(dataMain.selectedIndex[1]);
})
